<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Erfolgreiche Registrierung</h1>

                <p class="h2">Die Daten werden sicher und DSGVO-konform verarbeitet</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" weiterBtn :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 6
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

